import { render, staticRenderFns } from "./ZUser.vue?vue&type=template&id=87a45fee&scoped=true"
import script from "./ZUser.vue?vue&type=script&lang=js"
export * from "./ZUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a45fee",
  null
  
)

export default component.exports